import { ConnectorType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';

// Constraints Gireve imposes on a DC connector: power type DC, format CABLE, a voltage among
// the values below and a mandatory amperage (free value, enforced by the SDK validation).
export const DC_CONNECTOR_STANDARD = ConnectorType.IEC_62196_T2_COMBO;

export const DC_ALLOWED_VOLTAGES: number[] = [400, 500, 950];

export const DC_DEFAULT_VOLTAGE = 400;

export const isDcConnector = (standard?: ConnectorType | ''): boolean =>
  standard === DC_CONNECTOR_STANDARD;

/**
 * Voltages offered for a DC connector. A connector saved before the constraint may carry another
 * value: it stays selectable so that editing the connector never silently rewrites it.
 */
export const getDcVoltageOptions = (current?: number | ''): number[] =>
  typeof current === 'number' && !DC_ALLOWED_VOLTAGES.includes(current)
    ? [...DC_ALLOWED_VOLTAGES, current].sort((a, b) => a - b)
    : DC_ALLOWED_VOLTAGES;
